import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  hover = false,
  padding = 'md'
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  const hoverClasses = hover ? 'transform transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg' : '';
  const cursorClass = onClick ? 'cursor-pointer' : '';
  return <div className={`
        bg-white dark:bg-gray-800 
        rounded-xl shadow-md 
        border border-gray-100 dark:border-gray-700
        ${paddingClasses[padding]}
        ${hoverClasses}
        ${cursorClass}
        ${className}
      `} onClick={onClick} data-id="element-46">
      {children}
    </div>;
};
export default Card;